export const TableConfig = {
  headerHeight: 60,
  pagination: 50,
  rowHeight: 49,
};
